import { default as checkoutConsents } from './consents';

export const consents = {
  ...checkoutConsents,
};
